import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { ChildrenPropType } from '../../../../prop-types/children';

import style from './tab-list-container.module.less';

export const TabListContainer = ({ children, className }) => {
  return <div className={classnames(style['tab-list-container'], className)}>{children}</div>;
};

TabListContainer.propTypes = {
  children: ChildrenPropType.isRequired,
  className: PropTypes.string,
};
